import styled from '@emotion/styled';

const Wrapper = styled.div`
  align-items: center;
  display: inline-flex;
  gap: 10px;
`;

const LogoMark = styled.div`
  align-items: center;
  background: var(--color-accent-glow);
  border: 1px solid var(--color-accent);
  border-radius: var(--radius-sm);
  color: var(--color-accent);
  display: flex;
  font-family: var(--font-display);
  font-size: 0.75rem;
  font-weight: var(--font-weight-bold);
  height: 32px;
  justify-content: center;
  letter-spacing: 0.05em;
  width: 32px;
`;

const LogoText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
`;

const AppName = styled.span`
  color: var(--color-text-primary);
  font-family: var(--font-ui);
  font-size: 0.9375rem;
  font-weight: var(--font-weight-bold);
  letter-spacing: 0.03em;
  line-height: 1;
`;

const AppSub = styled.span`
  color: var(--color-text-muted);
  font-family: var(--font-ui);
  font-size: 0.65rem;
  letter-spacing: var(--letter-spacing-label);
  text-transform: uppercase;
`;

export default function Logo() {
  return (
    <Wrapper>
      <LogoMark>CT</LogoMark>
      <LogoText>
        <AppName>cryotype</AppName>
        <AppSub>typing test</AppSub>
      </LogoText>
    </Wrapper>
  );
}
